import React, { useEffect, useState } from 'react';
import { getCostInvoiceUrl } from '../../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { FileText } from 'lucide-react';

export const CostInvoicePreview = ({ cost, open, onOpenChange }) => {
    const [objectUrl, setObjectUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!open || !cost?.id) return;
        let cancelled = false;
        let url = null;
        (async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await fetch(getCostInvoiceUrl(cost.id), { credentials: 'include' });
                if (!res.ok) throw new Error('Erreur chargement');
                const blob = await res.blob();
                url = URL.createObjectURL(blob);
                if (!cancelled) setObjectUrl(url);
            } catch (e) {
                if (!cancelled) setError(e.message);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
            if (url) URL.revokeObjectURL(url);
            setObjectUrl(null);
        };
    }, [open, cost?.id]);

    if (!cost) return null;
    const type = cost.invoice_content_type || '';
    const name = cost.invoice_filename || 'facture.bin';
    const isImage = type.startsWith('image/') || /\.(png|jpe?g|gif|webp)$/i.test(name);
    const isPdf = type === 'application/pdf' || /\.pdf$/i.test(name);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-4xl max-h-[90vh] overflow-auto" data-testid="cost-invoice-preview-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center justify-between">
                        <span className="truncate pr-4 flex items-center gap-2">
                            <FileText className="w-4 h-4" /> {name}
                        </span>
                        {objectUrl && (
                            <a
                                href={objectUrl}
                                download={name}
                                className="text-sm text-[#E85A24] hover:underline flex items-center gap-1 shrink-0"
                            >
                                Télécharger
                            </a>
                        )}
                    </DialogTitle>
                </DialogHeader>
                <div className="min-h-[300px] flex items-center justify-center">
                    {loading && <div className="w-8 h-8 border-4 border-[#E85A24] border-t-transparent rounded-full animate-spin" />}
                    {error && <p className="text-red-600 text-sm">{error}</p>}
                    {!loading && !error && objectUrl && isImage && (
                        <img src={objectUrl} alt={name} className="max-w-full max-h-[75vh] object-contain" />
                    )}
                    {!loading && !error && objectUrl && isPdf && (
                        <iframe src={objectUrl} className="w-full h-[75vh] border-0" title={name} />
                    )}
                    {!loading && !error && objectUrl && !isImage && !isPdf && (
                        <a href={objectUrl} target="_blank" rel="noreferrer" className="text-[#E85A24] hover:underline">
                            Ouvrir la facture
                        </a>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};
